.kai {
    svg {
        width: 28px;
        height: 28px;
    }
}
